import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Experience() {
  return (
    <section className="header-experience">
      <div className="container container-desk">
        <div className="content">
          <h2 className="about-title js-splittext-lines">
            <div className="color-gray">
              <span className="fsz-65 color-brown1 text-uppercase font-palast-regular ltspc-1">
                A experiência
              </span>
            </div>
          </h2>
          <p
            className="color-gray mt-50 js-splittext-lines ltspc-2 lh-2"
            data-wow-delay="0.2s"
          >
            <span className="fsz-18">
              No Wiser, viver é
              <strong className="fsz-20 fst-italic fw-600 lh-2 ltspc-1 text-white font-palast-bold-italic">
                {" "}
                sinônimo de conveniência e sofisticação.{" "}
              </strong>
              Aqui, morar, trabalhar e desfrutar se entrelaçam em um só lugar,
              criando uma experiência de vida que vai além do comum.
            </span>
          </p>
          <p
            className="color-gray mt-15 js-splittext-lines ltspc-2 lh-2"
            data-wow-delay="0.2s"
          >
            <span className="fsz-18">
              Cada espaço foi cuidadosamente planejado para proporcionar
              funcionalidade e elegância, enquanto
              <strong className="fsz-20 fst-italic fw-600 lh-2 ltspc-1 text-white font-palast-bold-italic">
                {" "}
                serviços exclusivos{" "}
              </strong>
              acompanham você em cada passo, trazendo praticidade e conforto em
              qualquer direção.
            </span>
          </p>
          <p
            className="color-gray mt-15 js-splittext-lines ltspc-2 lh-2"
            data-wow-delay="0.2s"
          >
            <span className="fsz-18">
              E para celebrar os momentos mais especiais, o Social Club do Wiser
              oferece um ambiente único, onde experiências se tornam memórias
              inesquecíveis. Um espaço pensado para aqueles que
              <strong className="fsz-20 fst-italic fw-600 lh-2 ltspc-1 text-white font-palast-bold-italic">
                {" "}
                valorizam a arte de viver bem{" "}
              </strong>
              e sabem que o verdadeiro luxo está em cada detalhe.
            </span>
          </p>
        </div>
      </div>

      <div className="container-mobile">
        <div className="col-lg-12">
          <LazyLoadImage
            src="/home_borin/assets/images/experience-mobile.webp"
            alt="imagem com vista para fora"
            className="img-cover"
            effect="blur"
            width={"100%"}
            height={"707px"}
          />
        </div>

        <div className="content">
          <h2 className="js-splittext-lines">
            <div className="color-gray title-experience">
              <span className="fsz-65 color-brown1 text-uppercase font-palast-regular ltspc-1">
                Experiência
              </span>
            </div>
          </h2>
          <p
            className="color-gray mt-50 js-splittext-lines ltspc-2 lh-2"
            data-wow-delay="0.2s"
          >
            <span className="fsz-18">
              No Wiser, viver é
              <strong className="fsz-20 fst-italic fw-600 lh-2 ltspc-1 text-white font-palast-bold-italic">
                {" "}
                sinônimo de conveniência e sofisticação.{" "}
              </strong>
              Aqui, morar, trabalhar e desfrutar se entrelaçam em um só lugar,
              criando uma experiência de vida que vai além do comum.
            </span>
          </p>
          <p
            className="color-gray mt-15 js-splittext-lines ltspc-2 lh-2"
            data-wow-delay="0.2s"
          >
            <span className="fsz-18">
              Cada espaço foi cuidadosamente planejado para proporcionar
              funcionalidade e elegância, enquanto
              <strong className="fsz-20 fst-italic fw-600 lh-2 ltspc-1 text-white font-palast-bold-italic">
                {" "}
                serviços exclusivos{" "}
              </strong>
              acompanham você em cada passo, trazendo praticidade e conforto em
              qualquer direção.
            </span>
          </p>
          <p
            className="color-gray mt-15 js-splittext-lines ltspc-2 lh-2"
            data-wow-delay="0.2s"
          >
            <span className="fsz-18">
              E para celebrar os momentos mais especiais, o Social Club do Wiser
              oferece um ambiente único, onde experiências se tornam memórias
              inesquecíveis. Um espaço pensado para aqueles que
              <strong className="fsz-20 fst-italic fw-600 lh-2 ltspc-1 text-white font-palast-bold-italic">
                {" "}
                valorizam a arte de viver bem{" "}
              </strong>
              e sabem que o verdadeiro luxo está em cada detalhe.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default Experience;
